import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ContactoPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Contact Section */}
      <section className="mt-16 sm:mt-20 lg:mt-24">
        <div className="grid lg:grid-cols-2 min-h-[calc(100vh-4rem)] sm:min-h-[calc(100vh-5rem)] lg:min-h-[calc(100vh-6rem)]">
          {/* Left Side - Image */}
          <div className="relative h-48 sm:h-64 md:h-80 lg:h-auto bg-[#1a3a2e]">
            <img
              src="https://static.readdy.ai/image/0538348e5f7265469219be823f4b4c0f/2c80217b5d6e991d333cfe813d9460a6.png"
              alt="Tienda Artaca Tactic"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1a3a2e]/90 via-[#1a3a2e]/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-4 sm:p-6 md:p-8 lg:p-12">
              <span className="text-white text-[10px] sm:text-xs font-semibold tracking-widest mb-2 sm:mb-3 block">
                (VISÍTANOS)
              </span>
              <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-5xl font-bold leading-tight">
                ESTAMOS EN<br />
                MEGAMALL<br />
                PANAMÁ
              </h2>
            </div>
          </div>

          {/* Right Side - Contact Info */}
          <div className="bg-white p-5 sm:p-8 md:p-10 lg:p-16 flex flex-col justify-center">
            <div className="max-w-xl mx-auto w-full">
              <div className="text-center mb-8 sm:mb-10 lg:mb-12">
                <h2 className="text-black text-2xl sm:text-3xl lg:text-5xl font-semibold mb-2 sm:mb-3">
                  Contáctanos
                </h2>
                <p className="text-gray-600 text-sm sm:text-base lg:text-lg">
                  Estamos aquí para ayudarte
                </p>
              </div>

              <div className="space-y-5 sm:space-y-6 lg:space-y-8 mb-8 sm:mb-10 lg:mb-12">
                {/* Phone */}
                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 lg:w-14 lg:h-14 bg-[#7cb342] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-white text-lg sm:text-xl lg:text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-black font-bold text-base sm:text-lg lg:text-xl mb-0.5 sm:mb-1">
                      Teléfono
                    </h3>
                    <a
                      href="tel:+50765358000"
                      className="text-gray-600 text-sm sm:text-base lg:text-lg hover:text-[#7cb342] transition-colors"
                    >
                      6535-8000
                    </a>
                  </div>
                </div>

                {/* WhatsApp */}
                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 lg:w-14 lg:h-14 bg-[#7cb342] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-white text-lg sm:text-xl lg:text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-black font-bold text-base sm:text-lg lg:text-xl mb-0.5 sm:mb-1">
                      WhatsApp
                    </h3>
                    <a
                      href="https://wa.me/50765358000"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-600 text-sm sm:text-base lg:text-lg hover:text-[#7cb342] transition-colors cursor-pointer"
                    >
                      +507 6535-8000
                    </a>
                  </div>
                </div>

                {/* Instagram */}
                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 lg:w-14 lg:h-14 bg-[#7cb342] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-instagram-line text-white text-lg sm:text-xl lg:text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-black font-bold text-base sm:text-lg lg:text-xl mb-0.5 sm:mb-1">
                      Instagram
                    </h3>
                    <a
                      href="https://instagram.com/artaca4"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-600 text-sm sm:text-base lg:text-lg hover:text-[#7cb342] transition-colors cursor-pointer"
                    >
                      @artaca4
                    </a>
                  </div>
                </div>

                {/* Location */}
                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 lg:w-14 lg:h-14 bg-[#7cb342] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-white text-lg sm:text-xl lg:text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-black font-bold text-base sm:text-lg lg:text-xl mb-0.5 sm:mb-1">
                      Ubicación
                    </h3>
                    <p className="text-gray-600 text-sm sm:text-base lg:text-lg leading-relaxed">
                      Megamall Panamá<br />
                      Pasillo Entrada Azul<br />
                      Kiosco #114, frente a Jamar
                    </p>
                  </div>
                </div>

                {/* Hours */}
                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 lg:w-14 lg:h-14 bg-[#7cb342] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-white text-lg sm:text-xl lg:text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-black font-bold text-base sm:text-lg lg:text-xl mb-0.5 sm:mb-1">
                      Horario
                    </h3>
                    <p className="text-gray-600 text-sm sm:text-base lg:text-lg leading-relaxed">
                      Lunes a Domingo<br />
                      10:00 AM - 9:00 PM
                    </p>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <a
                  href="https://wa.me/50765358000"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 bg-[#7cb342] hover:bg-[#689f38] text-white py-3 sm:py-3.5 lg:py-4 rounded-full font-semibold text-sm sm:text-base lg:text-lg flex items-center justify-center space-x-2 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-lg sm:text-xl w-5 h-5 flex items-center justify-center"></i>
                  <span>CHATEAR</span>
                </a>
                <a
                  href="tel:+50765358000"
                  className="flex-1 border-2 border-[#1a3a2e] hover:bg-[#1a3a2e] text-[#1a3a2e] hover:text-white py-3 sm:py-3.5 lg:py-4 rounded-full font-semibold text-sm sm:text-base lg:text-lg flex items-center justify-center space-x-2 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line text-lg sm:text-xl w-5 h-5 flex items-center justify-center"></i>
                  <span>LLAMAR</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google Maps Section */}
      <section className="h-[40vh] sm:h-[50vh] md:h-[60vh]">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.5!2d-79.5195!3d9.0082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8faca8dbd6b98b03%3A0x5fc5e3a4b9a3c8e7!2sArtaca%20Tactic%20Panama!5e0!3m2!1ses!2spa!4v1700000000000!5m2!1ses!2spa"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Ubicación Artaca Tactic Panama en Megamall"
        ></iframe>
      </section>

      <Footer />
    </div>
  );
}
